<template>
  <h2 class="text-center">Tu cuenta se esta verificando</h2>
</template>

<script>
import { verifyAccount } from '../store/actions';

export default {
  vuex: {
    actions: {
      verifyAccount
    }
  },

  ready() {
    /* Send the token to verify the account. */
    this.verifyAccount(this.$route.params.token);
  }
}
</script>


// WEBPACK FOOTER //
// Verify-account.vue?2cf68604